import React, { useContext, useState } from "react";
import { Area1Set, PromodeSet } from "../App";
import { ButtonFlytohome } from "./buttonFlytohome";
import { ButtonFullscreen } from "./buttonFullscreen";
import { ButtonMaps } from "./buttonMaps";
import { ButtonRotate } from "./buttonRotate";
import ParamsSet from "./ParamsSet";
import ReloadButton from "./ReloadButton";
// import { ButtonYears } from "./buttonYears";

export const DaiproHeader = ({ metadata }) => {
  const { area1set } = useContext(Area1Set);
  const [headerview, setHeaderview] = useState(true);
  const { promodeset, setPromodeSet } = useContext(PromodeSet);

  const handleChangerepeat = () => {
    setHeaderview(!headerview);
  };

  return (
    <>
      <div
        className={`absolute top-0 z-40 pointer-events-auto md:rounded-xl bg-gray-200 ${
          headerview ? "animate-fade-in-down" : "animate-fade-in-up"
        }`}
        x-data="app"
      >
        <div>
          <input
            name="header"
            id="ヘッダ表示"
            type="checkbox"
            // value="ヘッダ表示"
            onChange={handleChangerepeat}
            checked={false == headerview}
            className="peer hidden"
          />
          {headerview ? (
            <label
              htmlFor="ヘッダ表示"
              className={`block cursor-pointer select-none md:rounded-sm text-center text-xl md:text-3xl lg:text-4xl peer-checked:bg-blue-500 peer-checked:text-white`}
            >
              ▲
            </label>
          ) : (
            <label
              htmlFor="ヘッダ表示"
              className={`block cursor-pointer select-none md:rounded-sm text-center text-xs md:text-sm lg:text-base peer-checked:bg-blue-500 peer-checked:text-white`}
            >
              ▼表示する
            </label>
          )}
        </div>
      </div>

      <div
        className={`justify-center w-full absolute z-30 pointer-events-none md:h-20`}
      >
        {/* <div className="absolute z-20 bottom-0 min-w-full text-black-900 py-1 text-center bg-gradient-to-r from-white/90 via-white/70 to-white/30 pointer-events-none"> */}
        <div
          className={`md:flex justify-center w-full pointer-events-none bg-gradient-to-r from-white/50 via-white/70 to-white/50 ${
            headerview ? "animate-fade-in-down" : "animate-fade-out-up"
          }`}
        >
          {/* <ButtonYears /> */}

          <ParamsSet />
          <ReloadButton />
          <ButtonMaps />
        </div>
      </div>

      <div
        className={`md:flex w-full absolute z-30 pointer-events-none ${
          headerview
            ? "animate-keep-down mt-12 md:mt-20"
            : "animate-keep-up mt-0 md:mt-5"
        }`}
      >
        {promodeset && <ButtonFullscreen />}
        <ButtonFlytohome />
        <ButtonRotate />
      </div>

      {/* </div> */}
    </>
  );
};
